module.exports = __webpack_public_path__ + "img/img_kong@2x.faedd0e4.png";